import { useEffect, useRef } from 'react'

export const useOnClickOutside = (
  ref: React.MutableRefObject<HTMLElement | undefined>,
  handler: Function,
) => {
  useEffect(() => {
    const listener = (event: any) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }

      setTimeout(() => handler(event), 150)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
